export default {
  login: 'Login',
  user: 'Usuário',
  password: 'Senha',
  forgotPassword: 'Esqueceu sua senha?',
  signin: 'Entrar',
  welcomeEcargo: 'Bem-vindo ao e-Cargo',
  recoveryPassword: 'Recuperar senha',
  recovery: 'Recuperar',
  email: 'E-mail',
  passwordRecovered: 'Senha recuperada',
  weShipPassword: 'Enviamos para o seu e-mail uma nova senha provisória.',
  loginNow: 'Fazer login agora',
  // Favorites
  favorites: 'Favoritos',
  fastAccess: 'Acesso rápido as funções mais acessadas do sistema',
  // Menu
  menu: 'Menu',
  search: 'Procurar',
  // Notificaitons
  notifications: 'Notificações',
  lastAccess: 'Últimos Acessos',
  // Settings
  settings: 'Configurações',
  profile: 'Perfil',
  logout: 'Sair',
  fullName: 'Nome Completo',
  record: 'Gravar',
  cPassword: 'Confirme a nova senha',
  country: 'País',
  changePicture: 'Alterar Foto',
  cancel: 'Cancelar'
}
